var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6620C",
    d: "M12 21q-2.404 0-4.395-1.148q-1.992-1.148-3.194-3.036l3.6-3.62l3 2.5l5.316-5.315v3.33h1V8.673h-5.039v1h3.293l-4.592 4.63l-3-2.5l-4.108 4.09q-.425-.893-.653-1.874Q3 13.04 3 12q0-1.868.709-3.51T5.63 5.633t2.857-1.924T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.709 3.51q-.708 1.643-1.923 2.859t-2.858 1.925T12 21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.9067d46aaf5bc2bd00971ba4d238e9e5.svg";
export { ForwardRef as ReactComponent };